import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {withRouter} from 'react-router-dom';
import qs from 'qs';
import Titulo from '../comum/Titulo';
import {getFiscalEmbarque, getPerfisVendedores, getVendedorAgencia, getUsuarioHabilitadoVendaOffline} from '../../security/securityContext';
import Autorizacao, {validaPerfis} from '../../security/Autorizacao';
import AbaItinerario from './AbaItinerario';
import buscarCaixaAberto from '../../actions/fechamento-caixa/usuario/buscarCaixaAberto';
import selecionarDataIda from '../../actions/origem/selecionarDataIda';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarViagem from '../../actions/viagem/selecionarViagemIda';
import AbaSelecionarEMarcarPoltrona from './AbaSelecionarEMarcarPoltrona';
import AbaPassageiro from './AbaPassageiro';
import adicionarPassageirosIda from '../../actions/passageiro/adicionarPassageirosIda'
import adicionarPassageirosVolta from '../../actions/passageiro/adicionarPassageirosVolta';
import AbaDadosComprador from './AbaDadosComprador';
import AbaFormaPagamento from './AbaFormaPagamento';
import AbaResumoCompra from './AbaResumoCompra';
import {cadastrarReserva, pagarPedido, pagarPedidoLink, pagarPedidoCieloEcommerce, pagarPedidoSicoob, pagarPedidoStoneConnect, cancelarPedidoStoneConnect} from '../../actions/reserva/actionsReserva'
import { VENDA_SALVA_OFFLINE } from '../../actions/types'
import {arredondamentoPadrao, realParaNumber} from '../../util/numberUtil';
import remarcarReservas from '../../actions/reserva/remarcarReservas';
import alterarTipoEmissaoPassageiroIda from '../../actions/passageiro/alterarTipoEmissaoPassageiroIda';
import alterarTipoEmissaoPassageiroVolta from '../../actions/passageiro/alterarTipoEmissaoPassageiroVolta';
import selecionarReservasRemarcacao from '../../actions/remarcacao/selecionarReservasRemarcacao';
import {adicionarFormasPagamento} from '../../actions/viagem/adicionarFormasPagamento';
import adicionarDadosComprador from '../../actions/viagem/adicionarDadosComprador';
import selecionarDescontoUsuario from '../../actions/desconto/selecionarValorDescontoCalculado';
import buscarTiposDocumento from '../../actions/pessoa/buscarTiposDocumento';
import limpaViagens from '../../actions/viagem/limpaViagens';
import informarVendaEmMassa from '../../actions/viagem/informarVendaEmMassa';
import selecionarUsuario from '../../actions/usuario/selecionarUsuario'
import {alterarReservaParaCriada, alterarSituacaoFormaPagamentoReservaCriada} from '../../actions/reserva/selecionarReservaParaCriar';
import {verificarPagamento} from '../../actions/reserva/actionsReserva';
import {usuarioEmpresaHabilitadoPagamentoViaPOS, usuarioEmpresaHabilitadoPagamentoViaTEF, usuarioEmpresaHabilitadoPagamentoViaLink, usuarioEmpresaHabilitadoCieloEcommerce, usuarioEmpresaHabilitadoSicoob, usuarioEmpresaHabilitadoStoneConnect} from '../../actions/usuario/cadastrarUsuariosEmpresaEmLote';

import {
    TIPOS_EMISSAO_ACOMPANHANTE,
    TIPOS_EMISSAO_CORTESIA,
    TIPOS_EMISSAO_ID_JOVEM_100,
    TIPOS_EMISSAO_IDOSO_100,
    TIPOS_EMISSAO_P_LIVRE_POLICIAL_AUDITOR,
    TIPOS_EMISSOES,
    TIPOS_EMISSOES_COM_GRATUIDADE,
} from './TiposEmissoes';
import {showInfoMsg, showSuccessMsg} from '../../util/messagesUtil';
import {renderField} from '../../util/inputs';
import ReactTooltip from 'react-tooltip';
import {showErrorMsg} from '../../util/messagesUtil';
import {errorHasDomainViolations} from '../../util/responseUtil';
import {verificarItinerarioAtivoOuInativo} from '../../actions/itinerario/verificarItinerarioAtivoOuInativo';
import selecionarAcrescimoPassagemCalculado
    from '../../actions/acrescimo-passagem/selecionarAcrescimoPassagemCalculado';
import recuperarFormaPagamentosDesativados from '../../actions/forma-pagamento/recuperarFormaPagamentosDesativados';
import recuperarPagamentosDesativadosUsuario from '../../actions/forma-pagamento/recuperarPagamentosDesativadosUsuario';

export class PainelVenderPassagem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            abaSelecionada: 1,
            valorTotalPedido: 0,
            descontoInformado: 0.00,
            acrescimoPassagemInformado: 0.00,
            seFormaPagamentoNaoFoiSelecionado: false,
            vendaSeguroHabilitadaNaEmpresa: false,
            botaoConcluirVendaDisabled: true,
            habilitadoZerarValorMultaRemarcacao: false,
            linkPagamentoUrl: null,
            linkPagamentoGerado: false,
            linkPagamentoQrCode: null,
            stoneConnectAguardando: false,
            stoneConnectStatus: null

        };
    }

    UNSAFE_componentWillMount() {
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.buscarCaixaAberto(this.props.empresaSelecionada.id);
        }
    }

    ehPerfilVendedorAgencia() {
        return validaPerfis([getVendedorAgencia(this.props.empresaSelecionada.id)]);
    }

    componentDidMount() {
        const parametros = qs.parse(this.props.history.location.search, {ignoreQueryPrefix: true});
        this.props.buscarTiposDocumento();
        this.props.adicionarPassageirosIda([]);
        this.props.adicionarPassageirosVolta([]);
        this.props.adicionarFormasPagamento([]);
        this.props.usuarioEmpresaHabilitadoPagamentoViaPOS(this.props.empresaSelecionada.id);
        this.props.usuarioEmpresaHabilitadoPagamentoViaTEF(this.props.empresaSelecionada.id);
        this.props.usuarioEmpresaHabilitadoPagamentoViaLink(this.props.empresaSelecionada.id);        
        this.props.usuarioEmpresaHabilitadoCieloEcommerce(this.props.empresaSelecionada.id);
        this.props.usuarioEmpresaHabilitadoSicoob(this.props.empresaSelecionada.id);
        this.props.usuarioEmpresaHabilitadoStoneConnect(this.props.empresaSelecionada.id);
        this.props.recuperarFormaPagamentosDesativados(this.props.empresaSelecionada.id);
        this.props.recuperarPagamentosDesativadosUsuario(this.props.empresaSelecionada.id);
        if (!parametros.remarcacao) {
            this.limparTudo()
        }
        this.props.informarVendaEmMassa(false);
        if(this.props.usuariosEmpresa){
            this.setState({botaoConcluirVendaDisabled: this.props.usuariosEmpresa.habilitadoPagamentoViaTEF})
        }
    }

    componentWillUnmount() {
        // sair da tela (ex.: menu lateral) com pagamento aguardando não pode deixar o polling
        // de /status rodando em segundo plano
        clearInterval(this.pollingInterval);
    }

    componentDidUpdate(prevProps) {
        // Preencher dados do comprador automaticamente quando for remarcação e foiCriadoPorUsuarioSistema for true
        if (this.props.reservasSelecionadasRemarcacao && 
            this.props.reservasSelecionadasRemarcacao.length > 0 &&
            !this.deveExibirAbaComprador() &&
            !this.props.dadosPagamento &&
            prevProps.dadosPagamento !== this.props.dadosPagamento) {
            // Buscar dados do comprador da primeira reserva (assumindo que todas têm o mesmo comprador)
            const primeiraReserva = this.props.reservasSelecionadasRemarcacao[0];
            if (primeiraReserva.dadosCompradorDto) {
                const comprador = {
                    cpfComprador: primeiraReserva.dadosCompradorDto.cpfComprador || primeiraReserva.dadosCompradorDto.cpf,
                    nomeComprador: primeiraReserva.dadosCompradorDto.nomeComprador || primeiraReserva.dadosCompradorDto.nome,
                    telefoneComprador: primeiraReserva.dadosCompradorDto.telefoneComprador || primeiraReserva.dadosCompradorDto.telefone,
                    ddiComprador: primeiraReserva.dadosCompradorDto.ddiComprador || primeiraReserva.dadosCompradorDto.ddi || 32
                };
                this.props.adicionarDadosComprador(comprador);
            }
        }
    }

    selecionarDescontoInformado(desconto) {
        this.setState({descontoInformado: desconto})
    }

    selecionarAcrescimoPassagemInformado(acrescimo) {
        this.setState({acrescimoPassagemInformado: acrescimo})
    }

    deveExibirAbaComprador() {
        // Não exibir aba comprador se for remarcação e foiCriadoPorUsuarioSistema for true
        if (this.props.reservasSelecionadasRemarcacao && this.props.reservasSelecionadasRemarcacao.length > 0) {
            const temReservaCriadaPorUsuarioSistema = this.props.reservasSelecionadasRemarcacao.some(it => it.foiCriadoPorUsuarioSistema);
            if (temReservaCriadaPorUsuarioSistema) {
                return false;
            }
        }
        return true;
    }

    seExibiAbaFormaPagamentoAvancar() {
        if (this.calcularValorTotal() === 0) {
            this.setState({abaSelecionada: this.state.abaSelecionada + 2})
        } else {
            this.setState({abaSelecionada: this.state.abaSelecionada + 1})
        }
    }

    seExibiAbaFormaPagamentoVoltar() {
        // Usa calcularValorTotal(false) para ignorar o checkbox ao decidir a navegação,
        // preservando o estado do checkbox para o usuário ao voltar para Pagamento
        if (this.calcularValorTotal(false) === 0) {
            this.setState({ abaSelecionada: this.state.abaSelecionada - 2 });
        } else {
            this.setState({ abaSelecionada: this.state.abaSelecionada - 1 });
        }
    }


    avancar() {
        if (this.state.abaSelecionada === 3 && !this.deveExibirAbaComprador()) {
            // Pula a aba 4 (Comprador) se não deve ser exibida
            this.seExibiAbaFormaPagamentoAvancar()
        } else if (this.state.abaSelecionada === 4) {
            this.seExibiAbaFormaPagamentoAvancar()
        } else if (this.state.abaSelecionada === 5) {
            this.preencherFormaPagamento();
            this.setState({abaSelecionada: this.state.abaSelecionada + 1})
        } else {
            this.setState({abaSelecionada: this.state.abaSelecionada + 1})
        }
    }

    voltar() {
        this.pararPagamentoEmAndamento();
        if (this.props.ehVendaEmMassa) {
            this.setState({abaSelecionada: 2})
        } else if (this.state.abaSelecionada === 6) {
            this.seExibiAbaFormaPagamentoVoltar()
        } else if (this.state.abaSelecionada === 5 && !this.deveExibirAbaComprador()) {
            // Pula a aba 4 (Comprador) se não deve ser exibida
            this.setState({abaSelecionada: 3})
        } else {
            this.setState({abaSelecionada: this.state.abaSelecionada - 1})
        }
    }

    abaSelecionada(aba) {
        if (this.state.abaSelecionada >= aba) {
            return 'nav-link active'
        }
        return 'nav-link'
    }

    tratarAvancarPassageiro() {
        const pass = this.props.passageirosIda.filter(p => !p.nome).length > 0;
        if (this.props.passageirosVolta && this.props.passageirosVolta.length > 0) {
            const passVolta = this.props.passageirosVolta.filter(p => !p.nome).length > 0;
            return !this.props.passageirosIda
                || !this.props.passageirosVolta
                || pass || passVolta
                || this.props.passageirosIda.length === 0
                || this.props.passageirosVolta.length === 0
        }
        
        if (this.props.reservasSelecionadasRemarcacao && this.props.passageirosIda && this.props.passageirosIda.length) {
            const validarPassIda = this.props.passageirosIda.filter(p => !p.documentoComFoto || !p.tipoEmissao || !p.dtNascimento).length > 0
            if (validarPassIda) showErrorMsg('Faltando dados do Passageiro, verifique!');

            return validarPassIda
        }

        if (this.props.reservasSelecionadasRemarcacao && this.props.passageirosVolta && this.props.passageirosVolta.length) {
            const validarPassVolta = this.props.passageirosVolta.filter(p => !p.documentoComFoto || !p.tipoEmissao || !p.dtNascimento).length > 0
            if (validarPassVolta) showErrorMsg('Faltando dados do Passageiro, verifique!');
            return validarPassVolta
        }

        return !this.props.passageirosIda || pass || this.props.passageirosIda.length === 0
        
    }

    gerarCPF() {
        var cpfBase = '';
        for (var i = 0; i < 9; i++) {
            cpfBase += Math.floor(Math.random() * 10);
        }

        var digito1 = this.calcularDigitoVerificador(cpfBase, 10);
        var digito2 = this.calcularDigitoVerificador(cpfBase + digito1, 11);

        return cpfBase + digito1 + digito2;
    }

    calcularDigitoVerificador(base, peso) {
        var soma = 0;
        for (var i = 0; i < base.length; i++) {
            soma += parseInt(base.charAt(i)) * peso--;
        }
        var resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    }

    gerarCPFsUnicos(quantidade) {
        var cpfs = new Set();

        while (cpfs.size < quantidade) {
            var novoCPF = this.gerarCPF();
            cpfs.add(novoCPF);
        }

        return Array.from(cpfs);
    }

    //Só remarcação
    preecherPassageiro() {
        if (this.props.reservasSelecionadasRemarcacao) {
            const idas = [];
            // eslint-disable-next-line array-callback-return
            this.props.reservasSelecionadasRemarcacao.map((reserva, index) => {
                const passageiro = Object.assign({}, reserva.passageiroDto);
                const passIda = this.props.passageirosIda[index];

                if (passIda && passIda.poltronaId !== reserva.poltronaId) {
                    passageiro.poltronaId = passIda.poltronaId;
                    passageiro.numeroPoltrona = passIda.numeroPoltrona;
                    passageiro.sentido = passIda.sentido;
                    passageiro.criancaColo = passageiro.criancaDto !== null;
                    // eslint-disable-next-line prefer-destructuring
                    passageiro.tipoEmissao = TIPOS_EMISSOES.concat(TIPOS_EMISSOES_COM_GRATUIDADE)
                        .concat(TIPOS_EMISSAO_ACOMPANHANTE)
                        .filter(f => f.value === passageiro.tipoEmissao)[0].value;
                    passageiro.valor = passIda.valor;
                    passageiro.taxaEmbarque = this.props.viagemIda.taxaEmbarque;
                    idas.push(passageiro)
                }
            });
            this.props.adicionarPassageirosIda(idas)
        }
    }

    preecherPassageiroCadastroEmMassa() {
        this.props.informarVendaEmMassa(true);
        if (this.props.passageirosIda || this.props.passageirosVolta) {
            const idas = [];
            const voltas = [];
            if (this.props.passageirosIda) {
                const cpfValidos = this.gerarCPFsUnicos(this.props.passageirosIda.length);
                this.props.passageirosIda.map(passageiro => {
                    const novoPassageiro = {
                        nome: 'Cadastro em massa ' + passageiro.numeroPoltrona,
                        criancaColo: null,
                        cpfPassageiro: cpfValidos.pop(),
                        documentoComFoto: '12345',
                        dtNascimento: '',
                        numeroPoltrona: passageiro.numeroPoltrona,
                        poltronaId: passageiro.poltronaId,
                        valor: passageiro.valor,
                        sentido: 'IDA',
                        criancaDto: null,

                        tipoEmissao: 'NORMAL',
                        nis: '',
                        validade: '',
                        dtNascimetoIdoso: '',
                        renda: 0.00,
                        cargoProfissao: '',
                        numeroDeficiente: '',
                        opcaoDescontoMeia: '',
                        telefone: '',
                        matricula: '',
                        taxaEmbarque: 0.00,
                        tipoDocumento: 'RG',
                        ddi: 32
                    };
                    idas.push(novoPassageiro)
                });
                this.props.adicionarPassageirosIda(idas);
            }

            if (this.props.passageirosVolta) {
                const cpfValidos = this.gerarCPFsUnicos(this.props.passageirosVolta.length);
                this.props.passageirosVolta.map(passageiro => {
                    const novoPassageiro = {
                        nome: 'Cadastro em massa ' + passageiro.numeroPoltrona,
                        criancaColo: null,
                        cpfPassageiro: cpfValidos.pop(),
                        documentoComFoto: '12345',
                        dtNascimento: '',
                        numeroPoltrona: passageiro.numeroPoltrona,
                        poltronaId: passageiro.poltronaId,
                        valor: passageiro.valor,
                        sentido: 'VOLTA',
                        criancaDto: null,
                        tipoEmissao: 'NORMAL',
                        nis: '',
                        validade: '',
                        dtNascimetoIdoso: '',
                        renda: 0.00,
                        cargoProfissao: '',
                        numeroDeficiente: '',
                        opcaoDescontoMeia: '',
                        telefone: '',
                        matricula: '',
                        taxaEmbarque: 0.00,
                        tipoDocumento: 'RG',
                        ddi:32
                    };
                    voltas.push(novoPassageiro)
                });
                this.props.adicionarPassageirosVolta(voltas);
            }


            const comprador = {
                cpfComprador: '123.456.789-09',
                nomeComprador: 'Venda em massa',
                telefoneComprador: '',
                ddiComprador: 32
            };
            this.props.adicionarDadosComprador(comprador);

            const pagamentos = [];
            const valorTotalReserva = this.calcularValorTotal();
            pagamentos.push({
                tipo: 'Dinheiro',
                codigoTipo: 'DINHEIRO',
                base64Comprovante: '',
                numeroComprovante: '',
                valor: valorTotalReserva,
                quantidadeParcelas: 1,
                descontoIda: null,
                descontoVolta: null,
                acrescimoPassagemIda: null,
                acrescimoPassagemVolta: null,
            });
            this.props.adicionarFormasPagamento(pagamentos);
        }
        this.setState({abaSelecionada: 6});
        this.abaSelecionada(6)

    }

    preencherFormaPagamento() {
        const pagamentos = [];
        if (this.props.cartaoCredito) {
            pagamentos.push({
                tipo: 'Cartão de Crédito',
                codigoTipo: 'CARTAO_CREDITO',
                base64Comprovante: this.props.base64Comprovante,
                numeroComprovante: this.props.numeroComprovante,
                valor: realParaNumber(this.props.valorCartaoCredito),
                quantidadeParcelas: Number(this.props.quantidadeParcelas),
                nomeComprovante: this.props.nomeComprovanteVenda,
                descontoIda: this.props.descontoIda,
                descontoVolta: this.props.descontoVolta,
                acrescimoPassagemIda: this.props.acrescimoPassagemIda,
                acrescimoPassagemVolta: this.props.acrescimoPassagemVolta,
                situacao: 'PENDENTE',
                habilitado: true,
            })
        }

        if (this.props.cartaoDebito) {
            pagamentos.push({
                tipo: 'Cartão de Débito',
                codigoTipo: 'CARTAO_DEBITO',
                base64Comprovante: this.props.base64Comprovante,
                numeroComprovante: this.props.numeroComprovante,
                valor: realParaNumber(this.props.valorCartaoDebito),
                quantidadeParcelas: Number(this.props.quantidadeParcelas),
                nomeComprovante: this.props.nomeComprovanteVenda,
                descontoIda: this.props.descontoIda,
                descontoVolta: this.props.descontoVolta,
                acrescimoPassagemIda: this.props.acrescimoPassagemIda,
                acrescimoPassagemVolta: this.props.acrescimoPassagemVolta,
                situacao: 'PENDENTE',
                habilitado: true,
            })
        }

        if (this.props.dinheiro) {
            pagamentos.push({
                tipo: 'Dinheiro',
                codigoTipo: 'DINHEIRO',
                base64Comprovante: '',
                numeroComprovante: '',
                valor: realParaNumber(this.props.valorDinheiro),
                quantidadeParcelas: 1,
                descontoIda: this.props.descontoIda,
                descontoVolta: this.props.descontoVolta,
                acrescimoPassagemIda: this.props.acrescimoPassagemIda,
                acrescimoPassagemVolta: this.props.acrescimoPassagemVolta,
                situacao: 'APROVADO',
                habilitado: false,
            })
        }

        if (this.props.pix) {
            pagamentos.push({
                tipo: 'PIX',
                codigoTipo: 'PIX',
                base64Comprovante: this.props.base64ComprovantePIX,
                numeroComprovante: this.props.numeroComprovantePIX,
                valor: realParaNumber(this.props.valorPIX),
                quantidadeParcelas: 1,
                nomeComprovante: this.props.nomeComprovanteVendaPIX,
                descontoIda: this.props.descontoIda,
                descontoVolta: this.props.descontoVolta,
                acrescimoPassagemIda: this.props.acrescimoPassagemIda,
                acrescimoPassagemVolta: this.props.acrescimoPassagemVolta,
                situacao: 'APROVADO',
                habilitado: false,
            })
        }

        if (this.props.pagamentoTEF) {
            pagamentos.push({
                tipo: 'Pagamento TEF',
                codigoTipo: 'TEF',
                base64Comprovante: '',
                numeroComprovante: '',
                valor: realParaNumber(this.props.valorTEF),
                quantidadeParcelas: 1,
                nomeComprovante: '',
                descontoIda: this.props.descontoIda,
                descontoVolta: this.props.descontoVolta,
                acrescimoPassagemIda: this.props.acrescimoPassagemIda,
                acrescimoPassagemVolta: this.props.acrescimoPassagemVolta,
                situacao: 'PENDENTE',
                habilitado: true,
            })
        }

        if (this.props.pagamentoLink) {
            pagamentos.push({
                tipo: 'Link Pagamento',
                codigoTipo: 'LINK_PAGAMENTO',
                base64Comprovante: '',
                numeroComprovante: '',
                valor: realParaNumber(this.props.valorLink),
                quantidadeParcelas: 1,
                nomeComprovante: '',
                descontoIda: this.props.descontoIda,
                descontoVolta: this.props.descontoVolta,
                acrescimoPassagemIda: this.props.acrescimoPassagemIda,
                acrescimoPassagemVolta: this.props.acrescimoPassagemVolta,
                situacao: 'PENDENTE',
                habilitado: true,
            })
        }

        if (this.props.pagamentoCieloEcommerce) {
            pagamentos.push({
                tipo: 'Cielo E-commerce PIX',
                codigoTipo: 'CIELO_ECOMMERCE',
                base64Comprovante: '',
                numeroComprovante: '',
                valor: realParaNumber(this.props.valorCieloEcommerce),
                quantidadeParcelas: 1,
                nomeComprovante: '',
                descontoIda: this.props.descontoIda,
                descontoVolta: this.props.descontoVolta,
                acrescimoPassagemIda: this.props.acrescimoPassagemIda,
                acrescimoPassagemVolta: this.props.acrescimoPassagemVolta,
                situacao: 'PROCESSANDO',
                habilitado: true,
            })
        }

        if (this.props.pagamentoStoneConnect) {
            pagamentos.push({
                tipo: 'Connect Stone',
                codigoTipo: 'STONE_CONNECT',
                base64Comprovante: '',
                numeroComprovante: '',
                valor: realParaNumber(this.props.valorStoneConnect),
                quantidadeParcelas: this.props.parcelasStoneConnect || 1,
                nomeComprovante: '',
                descontoIda: this.props.descontoIda,
                descontoVolta: this.props.descontoVolta,
                acrescimoPassagemIda: this.props.acrescimoPassagemIda,
                acrescimoPassagemVolta: this.props.acrescimoPassagemVolta,
                // campos extras exigidos pelo backend além do FormaPagamentoDto padrão -- ver
                // AbaResumoCompra.js/montarParametroReserva, que os eleva para o nível raiz do
                // comando de criação da reserva (ver plano de integração Connect Stone, seção 7.2)
                numeroSerieDispositivoStone: this.props.numeroSerieDispositivoStone,
                modoStoneConnect: this.props.modoStoneConnect || 'PAGAMENTO_DIRETO',
                tipoPagamentoStoneConnect: this.props.tipoPagamentoStoneConnect,
                parcelasStoneConnect: this.props.parcelasStoneConnect || 1,
                situacao: 'PROCESSANDO',
                habilitado: true,
            })
        }

        if (this.props.pagamentoSicoob) {
            pagamentos.push({
                tipo: 'Sicoob PIX',
                codigoTipo: 'SICOOB',
                base64Comprovante: '',
                numeroComprovante: '',
                valor: realParaNumber(this.props.valorSicoob),
                quantidadeParcelas: 1,
                nomeComprovante: '',
                descontoIda: this.props.descontoIda,
                descontoVolta: this.props.descontoVolta,
                acrescimoPassagemIda: this.props.acrescimoPassagemIda,
                acrescimoPassagemVolta: this.props.acrescimoPassagemVolta,
                situacao: 'PROCESSANDO',
                habilitado: true,
            })
        }

        this.props.adicionarFormasPagamento(pagamentos);
    }

    verificarSeFormaPagamentoNaoFoiSelecionado(dinheiro, cartaoCredito, cartaoDebito, pix) {
        if (cartaoCredito == undefined) cartaoCredito = false;
        if (cartaoDebito == undefined) cartaoDebito = false;
        this.setState({seFormaPagamentoNaoFoiSelecionado: dinheiro == false && cartaoCredito == false && pix == false && cartaoDebito == false && this.props.pagamentoTEF == false && this.props.pagamentoLink == false});
    }

    handleHabilitadoZerarValorMultaRemarcacao(e) {        
        this.setState({ habilitadoZerarValorMultaRemarcacao: e.target.checked });
    }

    limparHabilitadoZerarValorMultaRemarcacao() {
        this.props.changeFieldValue('formReserva', 'habilitadoZerarValorMultaRemarcacao', false);
        this.setState({ habilitadoZerarValorMultaRemarcacao: false });
    }

    somarValorFormaPagamento() {
        let valorTotalFormaPagamento = 0;
        // eslint-disable-next-line no-return-assign
        this.props.formasPagamento.forEach(fp => valorTotalFormaPagamento += Number(fp.valor));
        return arredondamentoPadrao(valorTotalFormaPagamento);
    }

    tratarAvancarPagamento() {
        if (this.state.seFormaPagamentoNaoFoiSelecionado) return true;

        // Bloqueia o avanço independente da soma dos valores bater -- sem maquininha
        // escolhida não há como enviar o pedido para a Stone processar o pagamento.
        if (this.props.pagamentoStoneConnect && !this.props.numeroSerieDispositivoStone) return true;

        // Idem para a forma de pagamento na maquininha -- deixou de ter um valor padrão
        // ("credit") fixo, já que agora depende dos meios habilitados para a empresa. Só se
        // aplica no modo Pagamento Direto; em "Listar Pedido" a forma é escolhida na maquininha.
        if (this.props.pagamentoStoneConnect && (this.props.modoStoneConnect || 'PAGAMENTO_DIRETO') === 'PAGAMENTO_DIRETO'
                && !this.props.tipoPagamentoStoneConnect) return true;

        const {
            submitting, invalid, pristine,
        } = this.props;

        return (submitting || invalid || pristine)
            && (!this.props.formasPagamento
                || (!this.props.formasPagamento && this.calcularValorTotal() === 0)
                || (this.somarValorFormaPagamento() !== this.calcularValorTotal()))
    }

    tratarBotaoAvancar() {
        switch (this.state.abaSelecionada) {
            case 1: {
                return !this.props.viagemIda
            }
            case 2: {
                if (this.props.reservasSelecionadasRemarcacao && this.props.reservasSelecionadasRemarcacao.length > 0) {
                    // Verificar se há reservas de conexão
                    const temReservasConexao = this.props.reservasSelecionadasRemarcacao.some(r => 
                        r.idsReservasConexao && r.idsReservasConexao.length > 0
                    );
                    
                    // Se não for remarcação de conexão, validar quantidade de poltronas
                    if (!temReservasConexao) {
                        return this.props.passageirosIda.length + this.props.passageirosVolta.length !== this.props.reservasSelecionadasRemarcacao.length
                    }
                    // Para reservas de conexão, verificar se há exatamente UMA poltrona selecionada
                    const totalPoltronas = (this.props.passageirosIda ? this.props.passageirosIda.length : 0) + 
                                          (this.props.passageirosVolta ? this.props.passageirosVolta.length : 0);
                    return totalPoltronas !== 1
                }
                return this.props.passageirosIda === null || this.props.passageirosIda.length === 0
            }
            case 3: {
                let idItinerario = this.props.viagemIda ? this.props.viagemIda.idItinerario : 0;
                idItinerario = idItinerario === 0 && this.props.viagemVolta ? this.props.viagemVolta.idItinerario : 0
                this.props.verificarItinerarioAtivoOuInativo(idItinerario)
                    .then((resp) => {
                        if (resp.payload.status === 200 && resp.payload.data === true && !(this.props.bloqueioPoltronasTemporario.bloqueios.length > 0)) {
                            showErrorMsg('O itinerário está inativo!');
                            this.props.limparTudo();
                        }
                    });
                return this.tratarAvancarPassageiro()
            }
            case 4: {
                if (!this.deveExibirAbaComprador()) {
                    // Se não deve exibir aba comprador, não deve bloquear avanço
                    return false;
                }
                return !this.props.dadosPagamento
            }
            case 5: {
                return this.tratarAvancarPagamento()
            }
            default: {
                return false;
            }
        }
    }

    alterarTipoEmissaoPassageiroIda() {
        if (this.props.reservasSelecionadasRemarcacao && this.props.reservasSelecionadasRemarcacao.length > 0) {
            this.props.alterarTipoEmissaoPassageiroIda();
            this.props.alterarTipoEmissaoPassageiroVolta()
        }
    }

    exibirBotoesRodape() {
        return (
            <div className="vx-footer-actions">
                <div className="vx-footer-left">
                    {this.state.abaSelecionada > 1 && this.state.abaSelecionada !== 7 && (
                        <button className="vx-btn-secondary" onClick={() => this.voltar()}>
                            <i className="material-icons">arrow_back</i>
                            Voltar
                        </button>
                    )}
                </div>
                <div className="vx-footer-right">
                    {this.state.abaSelecionada < 6 && this.state.abaSelecionada !== 2 &&
                     (this.state.abaSelecionada !== 4 || !this.deveExibirAbaComprador()) && (
                        <Autorizacao perfisPermitidos={[...getPerfisVendedores(this.props.empresaSelecionada.id)]}>
                            <button
                                className="vx-btn-primary"
                                onClick={() => this.avancar()}
                                disabled={this.tratarBotaoAvancar()}
                            >
                                Avançar
                                <i className="material-icons">arrow_forward</i>
                            </button>
                        </Autorizacao>
                    )}

                    {this.state.abaSelecionada === 2 && (
                        <Autorizacao perfisPermitidos={[...getPerfisVendedores(this.props.empresaSelecionada.id)]}>
                            <button
                                className="vx-btn-primary"
                                onClick={() => { this.avancar(); this.preecherPassageiro() }}
                                disabled={this.tratarBotaoAvancar()}
                            >
                                Avançar
                                <i className="material-icons">arrow_forward</i>
                            </button>
                        </Autorizacao>
                    )}

                    {this.state.abaSelecionada === 2 && (
                        <Autorizacao perfisPermitidos={[getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                            <button
                                className="vx-btn-secondary"
                                onClick={() => { this.avancar(); this.preecherPassageiroCadastroEmMassa() }}
                                disabled={this.tratarBotaoAvancar()}
                            >
                                Cadastrar em massa
                            </button>
                        </Autorizacao>
                    )}

                    {this.state.abaSelecionada === 4 && this.deveExibirAbaComprador() && (
                        <Autorizacao perfisPermitidos={[...getPerfisVendedores(this.props.empresaSelecionada.id)]}>
                            <button
                                className="vx-btn-primary"
                                onClick={() => { this.avancar(); this.alterarTipoEmissaoPassageiroIda() }}
                                disabled={this.tratarBotaoAvancar()}
                            >
                                Avançar
                                <i className="material-icons">arrow_forward</i>
                            </button>
                        </Autorizacao>
                    )}

                    {this.state.abaSelecionada === 6 && this.ehPagamentoLink() && this.state.linkPagamentoGerado && (
                        <button className="vx-btn-primary" onClick={() => this.limparTudo()}>
                            Nova Venda
                        </button>
                    )}

                    {this.state.abaSelecionada === 6 && this.ehPagamentoCieloEcommerce() && this.state.cieloEcommerceCopiaECola && (
                        <button className="vx-btn-primary" onClick={() => this.limparTudo()}>
                            Nova Venda
                        </button>
                    )}

                    {this.state.abaSelecionada === 6 && this.ehPagamentoSicoob() && this.state.sicoobCopiaECola && (
                        <button className="vx-btn-primary" onClick={() => this.limparTudo()}>
                            Nova Venda
                        </button>
                    )}

                    {this.state.abaSelecionada === 6 && this.ehPagamentoStoneConnect() && this.state.stoneConnectAguardando && (
                        <button className="vx-btn-primary" onClick={() => this.limparTudo()}>
                            Nova Venda
                        </button>
                    )}

                    {this.state.abaSelecionada === 6 && !this.ehPagamentoLink() && !this.ehPagamentoCieloEcommerce() && !this.ehPagamentoSicoob() && !this.ehPagamentoStoneConnect() && (
                        <button
                            className="vx-btn-primary"
                            onClick={() => this.criarReserva()}
                            disabled={this.props.pagamentoTEF}
                        >
                            Concluir venda
                        </button>
                    )}
                </div>
            </div>
        )
    }

    // Para o polling e zera o estado visual do gateway (link/QR/maquininha) -- usado ao Voltar,
    // pra que um pagamento iniciado e abandonado não continue consultando /status em segundo plano
    // (o Resumo remonta o criarReserva com pedidoId null e o polling órfão chamava
    // /pedido/null/.../status -> 400 -> tela de erro) nem deixe o Resumo travado com o QR antigo
    // e o botão de gerar desabilitado quando o vendedor avançar de novo.
    pararPagamentoEmAndamento() {
        clearInterval(this.pollingInterval);
        this.setState({
            linkPagamentoGerado: false,
            linkPagamentoUrl: null,
            linkPagamentoQrCode: null,
            cieloEcommerceAguardando: false,
            cieloEcommerceQrCode: null,
            cieloEcommerceCopiaECola: null,
            sicoobAguardando: false,
            sicoobQrCode: null,
            sicoobCopiaECola: null,
            stoneConnectAguardando: false,
            stoneConnectStatus: null
        });
    }

    // Sempre cancela o polling anterior antes de iniciar outro -- sem isso o intervalo antigo
    // perdia a referência e não podia mais ser parado (nem pelo limparTudo)
    iniciarPollingPagamento(formaPagamento) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = setInterval(() => this.verificarPagamento(formaPagamento), 15000);
    }

    limparTudo() {
        clearInterval(this.pollingInterval);
        this.setState({
            abaSelecionada: 1,
            linkPagamentoGerado: false,
            linkPagamentoUrl: null,
            linkPagamentoQrCode: null,            
            cieloEcommerceAguardando: false,
            cieloEcommerceQrCode: null,
            cieloEcommerceCopiaECola: null,
            sicoobAguardando: false,
            sicoobQrCode: null,
            sicoobCopiaECola: null
        });
        this.props.limpaViagens();
        this.props.adicionarPassageirosIda([]);
        this.props.adicionarPassageirosVolta([]);
        this.props.selecionarReservasRemarcacao(null);
        this.props.adicionarFormasPagamento(null);
        this.props.selecionarUsuario(null)
        this.props.selecionarDescontoUsuario({
            ida: 0.00,
            volta: 0.00,
        })
        this.props.selecionarAcrescimoPassagemCalculado({
            ida: 0.00,
            volta: 0.00,
        })
        this.limparHabilitadoZerarValorMultaRemarcacao();
    }

    ehPagamentoLink() {
        return this.props.criarReserva &&
            this.props.criarReserva.formasPagamentoDto &&
            this.props.criarReserva.formasPagamentoDto.some(f => f.codigoTipo === 'LINK_PAGAMENTO');
    }

    ehPagamentoCieloEcommerce() {
        return this.props.criarReserva &&
            this.props.criarReserva.formasPagamentoDto &&
            this.props.criarReserva.formasPagamentoDto.some(f => f.codigoTipo === 'CIELO_ECOMMERCE');
    }

    ehPagamentoSicoob() {
        return this.props.criarReserva &&
            this.props.criarReserva.formasPagamentoDto &&
            this.props.criarReserva.formasPagamentoDto.some(f => f.codigoTipo === 'SICOOB');
    }

    // Connect Stone só é concluído pelo webhook da Stone (charge.paid), nunca por clique
    // do vendedor -- "Concluir venda" some daqui, só "Enviar para Maquininha" fica visível
    // (ver AbaResumoCompra.js), igual ao padrão já usado por Link/Cielo E-commerce/Sicoob.
    ehPagamentoStoneConnect() {
        return this.props.criarReserva &&
            this.props.criarReserva.formasPagamentoDto &&
            this.props.criarReserva.formasPagamentoDto.some(f => f.codigoTipo === 'STONE_CONNECT');
    }

    criarReserva() {
        if (this.props.reservasSelecionadasRemarcacao) {            
            this.props.remarcarReservas(this.props.criarReserva, this.props.reservasSelecionadasRemarcacao.length > 0)
                .then((resp) => {
                    showSuccessMsg('Reserva remarcada com sucesso');
                    this.limparTudo();
                    this.props.history.push(`/recibo-passagem?pedido=${resp.payload.data}`)
                })
                .catch(err => {
                    if (err && err.offline) {
                        showErrorMsg(err.message)
                    }
                })
        } else {
            this.props.cadastrarReserva(this.props.criarReserva)
                .then((resp) => {
                    if (resp.type === VENDA_SALVA_OFFLINE) {
                        this.limparTudo();
                        this.props.history.push(`/recibo-offline?chave=${resp.payload}`);
                        return;
                    }
                    showSuccessMsg('Reserva cadastrada com sucesso');
                    this.limparTudo();
                    this.props.history.push(`/recibo-passagem?pedido=${resp.payload.data}`);
                })
                .catch(err => {
                    if (err && err.offline) {
                        showErrorMsg(err.message)
                    }
                })
        }
    }

    incluirIdPedido(idPedido){
        this.props.alterarReservaParaCriada(idPedido)
    }

    verificarSeFormaPagamentoAprovadas() {
        const todasAprovadas = this.props.criarReserva.formasPagamentoDto.every(forma => forma.situacao === 'APROVADO');
        if (todasAprovadas) {
            this.props.history.push(`/recibo-passagem?pedido=${this.props.criarReserva.pedidoId}`);
            this.limparTudo();
        }
    }

    verificarPagamento(formaPagamento) {
        const pedidoId = this.props.criarReserva && this.props.criarReserva.pedidoId;
        if (!pedidoId) {
            // pedido saiu de cena (Voltar/Nova Venda/remontagem do Resumo) -- para o polling em vez
            // de chamar /pedido/null/... e cair na tela de erro
            clearInterval(this.pollingInterval);
            return;
        }
        this.props.verificarPagamento(pedidoId, formaPagamento.codigoTipo).then((resp) => {
            if (resp.payload.data === 'APROVADO') {
                clearInterval(this.pollingInterval);
                this.setState({ cieloEcommerceAguardando: false, cieloEcommerceQrCode: null, cieloEcommerceCopiaECola: null, sicoobAguardando: false, sicoobQrCode: null, sicoobCopiaECola: null, stoneConnectAguardando: false, stoneConnectStatus: null });
                this.props.alterarSituacaoFormaPagamentoReservaCriada(formaPagamento, 'APROVADO', false);
                this.verificarSeFormaPagamentoAprovadas();
            }
            if (resp.payload.data === 'CANCELADO') {
                clearInterval(this.pollingInterval);
                this.setState({ cieloEcommerceAguardando: false, cieloEcommerceQrCode: null, cieloEcommerceCopiaECola: null, sicoobAguardando: false, sicoobQrCode: null, sicoobCopiaECola: null, stoneConnectAguardando: false, stoneConnectStatus: null });
                this.props.alterarSituacaoFormaPagamentoReservaCriada(formaPagamento, 'CANCELADO', true);
            }
            if (resp.payload.data === 'PENDENTE') {
                clearInterval(this.pollingInterval);
                this.setState({ cieloEcommerceAguardando: false, cieloEcommerceQrCode: null, cieloEcommerceCopiaECola: null, sicoobAguardando: false, sicoobQrCode: null, sicoobCopiaECola: null, stoneConnectAguardando: false, stoneConnectStatus: null });
                this.props.alterarSituacaoFormaPagamentoReservaCriada(formaPagamento, 'PENDENTE', true);
            }
            if (resp.payload.data === 'AGUARDANDO_CONFIRMACAO') {
                showInfoMsg('Aguardando confirmação de pagamento')
            }
        })
    }

    // O interceptor do axios já exibe as violações de domínio (412 com `violacoes`), ex.:
    // "Garantia de preço não encontrada... Selecionar novamente a poltrona.". Chamar showErrorMsg
    // de novo aqui substituía essa mensagem pela genérica (o MessagesBar mostra uma de cada vez),
    // então a genérica só aparece quando o backend não mandou violação (ex.: erro de rede).
    exibirErroPagamento(error, mensagemPadrao) {
        const dados = error && error.response && error.response.data;
        if (!errorHasDomainViolations(dados)) {
            showErrorMsg(mensagemPadrao);
        }
    }

    pagarPedido(formaPagamento) {
        this.props.pagarPedido(this.props.criarReserva)
            .then((resp) => {
                showSuccessMsg('Solicitação de pagamento enviada!! Por favor aguarde..');
                this.incluirIdPedido(resp.payload.data);
                this.iniciarPollingPagamento(formaPagamento);
            })
            .catch((error) => {
                this.exibirErroPagamento(error, 'Ocorreu um erro ao processar o pagamento. Por favor, tente novamente.');
                console.error('Erro ao processar o pagamento:', error);
                clearInterval(this.pollingInterval);
                this.props.alterarSituacaoFormaPagamentoReservaCriada(formaPagamento, 'PENDENTE', true);
            });
    }

    pagarPedidoLink(formaPagamento) {
        this.props.pagarPedidoLink(this.props.criarReserva)
            .then((resp) => {
                const { pedidoId, shortUrl, qrCodeLink } = resp.payload.data;
                showSuccessMsg('Link de pagamento gerado com sucesso!');
                this.incluirIdPedido(pedidoId);
                this.setState({ linkPagamentoGerado: true, linkPagamentoUrl: shortUrl, linkPagamentoQrCode: qrCodeLink });
                this.iniciarPollingPagamento(formaPagamento);
            })
            .catch((error) => {
                this.exibirErroPagamento(error, 'Ocorreu um erro ao gerar o link de pagamento. Por favor, tente novamente.');
                console.error('Erro ao gerar link de pagamento:', error);
            });
    }

    pagarPedidoCieloEcommerce(formaPagamento) {
        this.setState({ cieloEcommerceAguardando: true });
        this.props.pagarPedidoCieloEcommerce(this.props.criarReserva)
            .then((resp) => {
                const { pedidoId, qrCodeBase64, copiaECola } = resp.payload.data;
                this.incluirIdPedido(pedidoId);
                this.setState({ cieloEcommerceAguardando: false, cieloEcommerceQrCode: qrCodeBase64, cieloEcommerceCopiaECola: copiaECola });
                this.iniciarPollingPagamento(formaPagamento);
            })
            .catch((error) => {
                this.setState({ cieloEcommerceAguardando: false, cieloEcommerceQrCode: null, cieloEcommerceCopiaECola: null });
                this.exibirErroPagamento(error, 'Não foi possível gerar o QR Code PIX da Cielo E-commerce. Tente novamente.');
                console.error('Erro ao chamar Cielo E-commerce:', error);
            });
    }

    pagarPedidoSicoob(formaPagamento) {
        this.setState({ sicoobAguardando: true });
        this.props.pagarPedidoSicoob(this.props.criarReserva)
            .then((resp) => {
                const { pedidoId, copiaECola } = resp.payload.data;
                this.incluirIdPedido(pedidoId);
                this.setState({ sicoobAguardando: false, sicoobCopiaECola: copiaECola });
                this.iniciarPollingPagamento(formaPagamento);
            })
            .catch((error) => {
                this.setState({ sicoobAguardando: false, sicoobQrCode: null, sicoobCopiaECola: null });
                this.exibirErroPagamento(error, 'Não foi possível gerar o QR Code PIX da Sicoob. Tente novamente.');
                console.error('Erro ao chamar Sicoob:', error);
            });
    }

    pagarPedidoStoneConnect(formaPagamento) {
        this.setState({ stoneConnectAguardando: true, stoneConnectStatus: 'Enviando para a Stone Connect...' });
        this.props.pagarPedidoStoneConnect(this.props.criarReserva)
            .then((resp) => {
                const { pedidoId } = resp.payload.data;
                this.incluirIdPedido(pedidoId);
                this.setState({ stoneConnectStatus: 'Aguardando o cliente concluir o pagamento na maquininha...' });
                this.iniciarPollingPagamento(formaPagamento);
            })
            .catch((error) => {
                this.setState({ stoneConnectAguardando: false, stoneConnectStatus: null });
                this.exibirErroPagamento(error, 'Não foi possível enviar o pagamento para a Stone Connect. Tente novamente.');
                console.error('Erro ao chamar Stone Connect:', error);
            });
    }

    // Botão "Cancelar" ao lado de "Enviar para Maquininha" -- sem diálogo de confirmação aqui
    // (decidido, ver plano em demanda-a-fazer/stone-connect-cancelamento-pedido-pendente/), o
    // clique já dispara o cancelamento. NÃO estorna cobrança já aprovada -- só é chamado
    // enquanto stoneConnectAguardando, isto é, pagamento ainda não confirmado.
    // Após cancelar, volta pra busca de passagens (limparTudo, mesmo botão "Nova Venda" já usado
    // nos outros gateways) em vez de deixar reenviar na mesma tela -- reenviar a mesma venda
    // reusa a garantiaPrecoUuid já consumida no primeiro envio e quebra (ver plano de correção
    // em demanda-a-fazer/, NPE em calcularValorPedido).
    cancelarPedidoStoneConnect() {
        this.props.cancelarPedidoStoneConnect(this.props.criarReserva.pedidoId, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Envio para a maquininha cancelado.');
                this.limparTudo();
            })
            .catch((error) => {
                this.exibirErroPagamento(error, 'Não foi possível cancelar o envio para a Stone Connect. Tente novamente.');
                console.error('Erro ao cancelar Stone Connect:', error);
            });
    }

    habilitarVendaSeguro(check) {
        this.setState({vendaSeguroHabilitadaNaEmpresa: check})
    }

    exibirAbaSelecionada() {
        switch (this.state.abaSelecionada) {
            case 1: {
                return (<AbaItinerario avancar={this.avancar.bind(this)} />)
            }

            case 2: {
                return (<AbaSelecionarEMarcarPoltrona limparTudo={this.limparTudo.bind(this)}/>)
            }
            case 3: {
                return (<AbaPassageiro calcularValorTotal={this.calcularValorTotal.bind(this)}
                                       calcularValorTotalTaxa={this.calcularValorTotalTaxa.bind(this)}
                                       ehGratuidadeTotal={this.ehGratuidadeTotal.bind(this)}
                                       ehIdoso100={this.ehIdoso100.bind(this)}
                                       ehDeficiente={this.ehDeficiente.bind(this)}
                                       ehAcompanhante={this.ehAcompanhante.bind(this)}
                                       ehCortesia={this.ehCortesia.bind(this)}
                                       ehIdJovem100={this.ehIdJovem100.bind(this)}
                                       ehMeiaPassagem={this.ehMeiaPassagem.bind(this)}
                                       ehIdJovem50={this.ehIdJovem50.bind(this)}
                                       ehIdoso50={this.ehIdJovem50.bind(this)}
                                       habilitarVendaSeguro={this.habilitarVendaSeguro.bind(this)}
                                       vendaSeguroHabilitadaNaEmpresa={this.state.vendaSeguroHabilitadaNaEmpresa}/>)
            }
            case 4: {
                if (!this.deveExibirAbaComprador()) {
                    // Se não deve exibir aba comprador, avança para a próxima
                    return (<AbaFormaPagamento
                        calcularValorTotal={this.calcularValorTotal.bind(this)}
                        calcularValorTotalSemTarifaSeguro={this.calcularValorTotalSemTarifaSeguro.bind(this)}
                        selecionarDescontoInformado={this.selecionarDescontoInformado.bind(this)}
                        selecionarAcrescimoPassagemInformado={this.selecionarAcrescimoPassagemInformado.bind(this)}
                        verificarSeFormaPagamentoNaoFoiSelecionado={this.verificarSeFormaPagamentoNaoFoiSelecionado.bind(this)}
                        handleHabilitadoZerarValorMultaRemarcacao={this.handleHabilitadoZerarValorMultaRemarcacao.bind(this)}
                        ehPerfilVendedorAgencia={this.ehPerfilVendedorAgencia()}
                    />)
                }
                return (<AbaDadosComprador/>)
            }
            case 5: {
                return (<AbaFormaPagamento
                    calcularValorTotal={this.calcularValorTotal.bind(this)}
                    calcularValorTotalSemTarifaSeguro={this.calcularValorTotalSemTarifaSeguro.bind(this)}
                    selecionarDescontoInformado={this.selecionarDescontoInformado.bind(this)}
                    selecionarAcrescimoPassagemInformado={this.selecionarAcrescimoPassagemInformado.bind(this)}
                    verificarSeFormaPagamentoNaoFoiSelecionado={this.verificarSeFormaPagamentoNaoFoiSelecionado.bind(this)}
                    handleHabilitadoZerarValorMultaRemarcacao={this.handleHabilitadoZerarValorMultaRemarcacao.bind(this)}
                    ehPerfilVendedorAgencia={this.ehPerfilVendedorAgencia()}
                />)
            }
            case 6: {
                return (<AbaResumoCompra calcularValorTotal={this.calcularValorTotal.bind(this)}
                                         pagarPedido = {this.pagarPedido.bind(this)}
                                         pagarPedidoLink = {this.pagarPedidoLink.bind(this)}                                         
                                         pagarPedidoCieloEcommerce = {this.pagarPedidoCieloEcommerce.bind(this)}
                                         pagarPedidoSicoob = {this.pagarPedidoSicoob.bind(this)}
                                         pagarPedidoStoneConnect = {this.pagarPedidoStoneConnect.bind(this)}
                                         cancelarPedidoStoneConnect = {this.cancelarPedidoStoneConnect.bind(this)}
                                         pagamentoTEF = {this.props.pagamentoTEF}
                                         pagamentoLink = {this.props.pagamentoLink}
                                         linkPagamentoUrl = {this.state.linkPagamentoUrl}
                                         linkPagamentoGerado = {this.state.linkPagamentoGerado}
                                         linkPagamentoQrCode = {this.state.linkPagamentoQrCode}                                         
                                         cieloEcommerceAguardando = {this.state.cieloEcommerceAguardando}
                                         cieloEcommerceQrCode = {this.state.cieloEcommerceQrCode}
                                         cieloEcommerceCopiaECola = {this.state.cieloEcommerceCopiaECola}
                                         sicoobAguardando = {this.state.sicoobAguardando}
                                         sicoobQrCode = {this.state.sicoobQrCode}
                                         sicoobCopiaECola = {this.state.sicoobCopiaECola}
                                         stoneConnectAguardando = {this.state.stoneConnectAguardando}
                                         stoneConnectStatus = {this.state.stoneConnectStatus}
                                         descontoInformado={this.state.descontoInformado}
                                         ehGratuidadeTotal={this.ehGratuidadeTotal.bind(this)}
                                         habilitadoZerarValorMultaRemarcacao={this.state.habilitadoZerarValorMultaRemarcacao}/>)
            }

            default: {
                return '';
            }
        }
    }

    verificaTipoEmissao(tipo) {
        if (tipo && tipo.value === undefined) {
            return TIPOS_EMISSOES
                .concat(TIPOS_EMISSOES_COM_GRATUIDADE)
                .concat(TIPOS_EMISSAO_ACOMPANHANTE)
                .concat(TIPOS_EMISSAO_ID_JOVEM_100)
                .concat(TIPOS_EMISSAO_CORTESIA)
                .concat(TIPOS_EMISSAO_IDOSO_100)
                .concat(TIPOS_EMISSAO_P_LIVRE_POLICIAL_AUDITOR)
                .filter(f => f.value === tipo)[0]
        }
        return tipo
    }

    ehMeiaPassagem(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'ID_JOVEM_50'
            || emissao.value === 'IDOSO_50'
    }

    ehGratuidadeTotal(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return this.ehIdJovem100(tipoEmissao)
            || this.ehIdoso100(tipoEmissao)
            || this.ehDeficiente(tipoEmissao)
            || this.ehCortesia(tipoEmissao)
            || emissao.value === 'P_LIVRE_POLICIAL_AUDITOR'
            || this.ehAcompanhante(tipoEmissao)
    }

    ehIdoso100(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'IDOSO_100'
    }

    ehDeficiente(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'DEFICIENTE'
    }

    ehAcompanhante(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'ACOMPANHANTE'
    }

    ehCortesia(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'CORTESIA'
    }

    ehIdJovem100(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'ID_JOVEM_100'
    }

    ehIdJovem50(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'ID_JOVEM_50'
    }

    ehIdoso50(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'IDOSO_50'
    }

    calcularValorPassageiro(pass, viagem) {
        const garantiaPreco = this.props.bloqueioPoltronasTemporario.bloqueios.filter(b => b.poltronaId === pass.poltronaId)[0];
        const alteradoViagem = Object.assign({}, viagem, {
            precoMeia: garantiaPreco.precoMeia,
            precoANTTMeia: garantiaPreco.precoANTTMeia,
        });
        const alteradoPass = Object.assign({}, pass, {valor: viagem.usuarioEhHabilitadoVenderValorANTT ? garantiaPreco.precoANTT : garantiaPreco.preco});

        if (this.ehMeiaPassagem(pass.tipoEmissao)) {
            if (pass.opcaoDescontoMeia === 'EMPRESA') {
                return Number(alteradoViagem.precoMeia)
            }
            return Number(alteradoViagem.precoANTTMeia)
        }
        if (this.ehGratuidadeTotal(pass.tipoEmissao)) {
            return 0.00
        }
        return alteradoPass.valor
    }

    calcularValorTotalTaxa() {
        return this.calcularValorTotalTaxaEmbarque() + this.calcularValorTotalEmPedagio()
    }

    calcularValorTotalTaxaEmbarque() {
        let valorTotalTaxa = 0.00;
        if (this.props.passageirosIda && this.props.passageirosIda.length > 0) {
            this.props.passageirosIda.forEach((pass) => {
                if (!this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalTaxa += Number(this.props.viagemIda.taxaEmbarque)
                }
            })
        }
        if (this.props.passageirosVolta && this.props.passageirosVolta.length > 0) {
            this.props.passageirosVolta.forEach((pass) => {
                if (!this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalTaxa += Number(this.props.viagemVolta.taxaEmbarque)
                }
            })
        }
        return valorTotalTaxa;
    }

    calcularValorTotalEmPedagio() {
        let valorTotalPedagio = 0.00;
        if (this.props.passageirosIda && this.props.passageirosIda.length > 0) {
            this.props.passageirosIda.forEach((pass) => {
                if (!this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalPedagio += Number(this.props.viagemIda.pedagio)
                }
            })
        }
        if (this.props.passageirosVolta && this.props.passageirosVolta.length > 0) {
            this.props.passageirosVolta.forEach((pass) => {
                if (!this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalPedagio += Number(this.props.viagemVolta.pedagio)
                }
            })
        }
        return valorTotalPedagio;
    }

    calcularValorTotalSeguro() {
        let valorTotalSeguro = 0.00;
        if (this.props.passageirosIda && this.props.passageirosIda.length > 0) {
            this.props.passageirosIda.forEach((pass) => {
                if (pass.vendaSeguro && !this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalSeguro += Number(this.props.viagemIda.tarifaSeguro)
                }
            })
        }
        if (this.props.passageirosVolta && this.props.passageirosVolta.length > 0) {
            this.props.passageirosVolta.forEach((pass) => {
                if (pass.vendaSeguro && !this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalSeguro += Number(this.props.viagemVolta.tarifaSeguro)
                }
            })
        }
        return valorTotalSeguro;
    }


    calcularValorTotalSemTaxa() {
        return this.calcularValorTotal() - this.calcularValorTotalTaxaEmbarque() - this.calcularValorTotalEmPedagio() - this.calcularValorTotalSeguro()
    }

    calcularValorTotalSemTarifaSeguro() {
        return this.calcularValorTotal() - this.calcularValorTotalSeguro()
    }


    calcularValorTotal(zerarMultaOverride = null) {
        let valorIda = 0.00;
        let valorVolta = 0.00;
        let valorTotalTaxa = 0.00;
        let valorTotalPedagio = 0.00;
        if (this.existePassagens(this.props.passageirosIda)) {
            this.props.passageirosIda.forEach((pass) => {
                if (!this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalTaxa += Number(this.props.viagemIda.taxaEmbarque)
                    valorTotalPedagio += Number(this.props.viagemIda.pedagio)

                }
                const valor = this.calcularValorPassageiro(pass, this.props.viagemIda);
                if (valor) {
                    valorIda += Number(valor)
                }
            })
        }

        if (this.existePassagens(this.props.passageirosVolta)) {
            this.props.passageirosVolta.forEach((pass) => {
                if (!this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalTaxa += Number(this.props.viagemVolta.taxaEmbarque)
                    valorTotalPedagio += Number(this.props.viagemVolta.pedagio)

                }
                const valor = this.calcularValorPassageiro(pass, this.props.viagemVolta);
                if (valor) {
                    valorVolta += Number(valor)
                }
            })
        }
        const creditoRemarcacao = this.calcularValorTotalCreditoRemarcacao();
        if (creditoRemarcacao > 0) {
            const taxaRemarcacao = this.calcularValorTaxaRemarcacao(zerarMultaOverride);
            let valorAPagar = (Number(valorIda + valorVolta + valorTotalTaxa + valorTotalPedagio + this.calcularValorTotalSeguro()) - creditoRemarcacao);
            if (valorAPagar > 0) {
                valorAPagar += Number(taxaRemarcacao);
                return Number(arredondamentoPadrao(valorAPagar))
            }
            return Number(taxaRemarcacao)
        }
        const somatorioTotal = valorIda + valorVolta + valorTotalTaxa + valorTotalPedagio + this.calcularValorTotalSeguro();
        if (this.props.valorDescontoUsuarioCalculado.ida > 0 || this.props.valorDescontoUsuarioCalculado.volta > 0) {
            let valorDesconto = 0.00;
            if (this.props.valorDescontoUsuarioCalculado.ida) {
                valorDesconto += Number(this.props.valorDescontoUsuarioCalculado.ida)

            }
            if (this.props.valorDescontoUsuarioCalculado.volta) {
                valorDesconto += Number(this.props.valorDescontoUsuarioCalculado.volta)

            }

            return Number(arredondamentoPadrao(somatorioTotal - valorDesconto))
        }

        if (this.props.valorAcrescimoPassagemCalculado.ida > 0 || this.props.valorAcrescimoPassagemCalculado.volta > 0) {
            let valorAcrescimo = 0.00;
            if (this.props.valorAcrescimoPassagemCalculado.ida) {
                valorAcrescimo += Number(this.props.valorAcrescimoPassagemCalculado.ida)

            }
            if (this.props.valorAcrescimoPassagemCalculado.volta) {
                valorAcrescimo += Number(this.props.valorAcrescimoPassagemCalculado.volta)

            }

            return Number(arredondamentoPadrao(somatorioTotal + valorAcrescimo))
        }


        return Number(arredondamentoPadrao(somatorioTotal))
    }

    existePassagens(pasageiros) {
        return pasageiros && pasageiros.length > 0;
    }

    calcularValorTotalSeguroRemarcacao() {
        let valorTotal = 0.00;
        if (this.props.reservasSelecionadasRemarcacao) {
            // eslint-disable-next-line no-return-assign
            this.props.reservasSelecionadasRemarcacao.forEach(reserva => valorTotal += Number(reserva.tarifaSeguro))
        }
        return arredondamentoPadrao(valorTotal)
    }


    calcularValorTaxaRemarcacao(zerarMultaOverride = null) {
        const zerarMulta = zerarMultaOverride !== null
            ? zerarMultaOverride
            : this.state.habilitadoZerarValorMultaRemarcacao;
        let valorTotal = 0.00;
        if (this.props.reservasSelecionadasRemarcacao && !zerarMulta) {
            // eslint-disable-next-line no-return-assign
            this.props.reservasSelecionadasRemarcacao.forEach(reserva => valorTotal += Number(reserva.valorTaxaRemarcacao))
        }
        return arredondamentoPadrao(valorTotal)
    }


    calcularValorTotalCreditoRemarcacao() {
        let valorTotal = 0.00;
        if (this.props.reservasSelecionadasRemarcacao) {
            // eslint-disable-next-line no-return-assign
            this.props.reservasSelecionadasRemarcacao.forEach(reserva => valorTotal += Number(reserva.valorTotalReserva))
        }
        return arredondamentoPadrao(valorTotal)
    }

    exibirIconeTaxaEmbarqueEPedagio() {
        return <span className="align-self-center tooltip-info">
            <a data-tip data-for='taxa-embarque-pedagio'>
                <i className="material-icons ajuda-icon" style={{color: '#000'}}>&#xe263;</i>
            </a>
            <div className="tooltip-ut">
                <ReactTooltip className="tooltip-ut" id='taxa-embarque-pedagio'
                              type="dark" effect="solid">
                    <div className="row">Taxa de embarque: {this.calcularValorTotalTaxaEmbarque()
                        .toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}<br/> Total de pedágio: {this.calcularValorTotalEmPedagio().toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                    })}</div>
                </ReactTooltip>
            </div>
        </span>
    }

    exibirTotalizadores() {
        if (this.state.abaSelecionada > 1) {
            const fmt = (val) => val.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
            if (this.props.reservasSelecionadasRemarcacao) {
                return (
                    <div className="vx-totals-bar">
                        <div className="vx-total-item">
                            <span className="vx-total-label">Crédito remarcação</span>
                            <span className="vx-total-value">{fmt(this.calcularValorTotalCreditoRemarcacao())}</span>
                        </div>
                        <div className="vx-total-item">
                            <span className="vx-total-label">Taxa</span>
                            <span className="vx-total-value">
                                {fmt(this.calcularValorTotalTaxa())}
                                {this.exibirIconeTaxaEmbarqueEPedagio()}
                            </span>
                        </div>
                        <div className="vx-total-item">
                            <span className="vx-total-label">Multa remarcação</span>
                            <span className="vx-total-value">{fmt(this.calcularValorTaxaRemarcacao())}</span>
                        </div>
                        <div className="vx-total-item">
                            <span className="vx-total-label">Seguro</span>
                            <span className="vx-total-value">{fmt(this.calcularValorTotalSeguro())}</span>
                        </div>
                        <div className="vx-total-item">
                            <span className="vx-total-label">Valor a pagar</span>
                            <span className="vx-total-value">{fmt(this.calcularValorTotal())}</span>
                        </div>
                    </div>
                )
            }
            return (
                <div className="vx-totals-bar">
                    <div className="vx-total-item">
                        <span className="vx-total-label">Passagem</span>
                        <span className="vx-total-value">{fmt(this.calcularValorTotalSemTaxa())}</span>
                    </div>
                    <div className="vx-total-item">
                        <span className="vx-total-label">Taxa</span>
                        <span className="vx-total-value">
                            {fmt(this.calcularValorTotalTaxa())}
                            {this.exibirIconeTaxaEmbarqueEPedagio()}
                        </span>
                    </div>
                    <div className="vx-total-item">
                        <span className="vx-total-label">Seguro</span>
                        <span className="vx-total-value">{fmt(this.calcularValorTotalSeguro())}</span>
                    </div>
                    <div className="vx-total-item">
                        <span className="vx-total-label">Total</span>
                        <span className="vx-total-value">{fmt(this.calcularValorTotal())}</span>
                    </div>
                </div>
            )
        }
        return ''
    }

    exibir() {
        const vendaOfflinePermitida = !this.props.online && getUsuarioHabilitadoVendaOffline(this.props.empresaSelecionada.id);
        if (this.props.caixaAberto || vendaOfflinePermitida) {
            const allSteps = [
                { num: 1, label: 'Itinerário' },
                { num: 2, label: 'Poltronas' },
                { num: 3, label: 'Passageiro' },
                { num: 4, label: 'Comprador', conditional: true },
                { num: 5, label: 'Pagamento' },
                { num: 6, label: 'Resumo' },
            ]
            const visibleSteps = allSteps.filter(s => !s.conditional || this.deveExibirAbaComprador())
            return (
                <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                    <div className="vx-steps">
                        {visibleSteps.map((s, i) => {
                            const isDone = this.state.abaSelecionada > s.num
                            const isActive = this.state.abaSelecionada === s.num
                            return (
                                <React.Fragment key={s.num}>
                                    <div className={`vx-step${isDone || isActive ? ' vx-step--done' : ''}${isActive ? ' vx-step--active' : ''}`}>
                                        <div className="vx-step-circle">
                                            {isDone ? <i className="material-icons">check</i> : (i + 1)}
                                        </div>
                                        <span className="vx-step-label">{s.label}</span>
                                    </div>
                                    {i < visibleSteps.length - 1 && (
                                        <div className={`vx-step-line${isDone ? ' vx-step-line--done' : ''}`} />
                                    )}
                                </React.Fragment>
                            )
                        })}
                    </div>
                    <div className='card border-0'>
                        <div className='card-body'>
                            {this.exibirTotalizadores()}
                            {this.exibirAbaSelecionada()}
                        </div>
                        {this.exibirBotoesRodape()}
                    </div>
                </div>
            )
        }
        return <div className='col-12'>
            <div className="mt-2 alert alert-warning text-center" role="alert">
                Seu caixa está em análise de fechamento. Para efetuar mais vendas contate seu gerente.
            </div>
        </div>
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[...getPerfisVendedores(this.props.empresaSelecionada.id)]}
                         empresaSelecionada={this.props.empresaSelecionada}>
                <div>
                    <div className="row internas">
                        {this.props.reservasSelecionadasRemarcacao
                            ? <Titulo texto="Remarcar reserva" urlRetorno={this.props.online ? '/painel-pesquisa' : '/painel-destinos'}/>
                            : <Titulo texto="Nova reserva" urlRetorno={this.props.online ? '/painel-pesquisa' : '/painel-destinos'}/>
                        }

                        {this.exibir()}
                    </div>
                    <Field name="vendaEmMassa" type="hidden" component={renderField} css="form-control col-md-12"/>
                </div>
            </Autorizacao>)
    }
}

const selector = formValueSelector('formReserva');

export const mapStateToProps = state => ({
    passageirosIda: state.passageirosIda,
    usuariosEmpresa: state.usuariosEmpresa,
    passageirosVolta: state.passageirosVolta,
    formasPagamento: state.formasPagamento,
    dadosPagamento: state.dadosPagamento,
    viagemIda: state.viagemIda,
    viagemVolta: state.viagemVolta,
    poltronasSelecionadas: state.poltronasSelecionadas,
    pedidos: state.pedidos.pedidos,
    empresaSelecionada: state.empresaSelecionada,
    criarReserva: state.criarReserva,
    changeFieldValue,
    filtrosAdicionados: state.filtrosAdicionadosPedido,
    caixaAberto: state.caixaAberto,
    online: state.conexao ? state.conexao.online : true,
    viagens: state.viagens,
    origem: state.origem,
    destino: state.destino,
    reservasSelecionadasRemarcacao: state.remarcacao.reservasSelecionadas,
    passagueiroSelecionado: state.passageiro,
    tiposEmissoesSelecionados: state.tiposEmissoesSelecionados,
    valorDescontoUsuarioCalculado: state.valorDescontoUsuarioCalculado,
    ehVendaEmMassa: state.ehVendaEmMassa,
    bloqueioPoltronasTemporario: state.bloqueioPoltronasTemporario,
    cartao: selector(state, 'cartao'),
    cartaoCredito: selector(state, 'cartaoCredito'),
    cartaoDebito: selector(state, 'cartaoDebito'),
    valorCartao: selector(state, 'valorCartao'),
    valorCartaoCredito: selector(state, 'valorCartaoCredito'),
    valorCartaoDebito: selector(state, 'valorCartaoDebito'),
    pagamentoTEF: selector(state, 'pagamentoTEF'),
    pagamentoLink: selector(state, 'pagamentoLink'),
    valorLink: selector(state, 'valorLink'),
    pagamentoCieloEcommerce: selector(state, 'pagamentoCieloEcommerce'),
    valorCieloEcommerce: selector(state, 'valorCieloEcommerce'),
    pagamentoSicoob: selector(state, 'pagamentoSicoob'),
    valorSicoob: selector(state, 'valorSicoob'),
    pagamentoStoneConnect: selector(state, 'pagamentoStoneConnect'),
    valorStoneConnect: selector(state, 'valorStoneConnect'),
    numeroSerieDispositivoStone: selector(state, 'numeroSerieDispositivoStone'),
    modoStoneConnect: selector(state, 'modoStoneConnect'),
    tipoPagamentoStoneConnect: selector(state, 'tipoPagamentoStoneConnect'),
    parcelasStoneConnect: selector(state, 'parcelasStoneConnect'),
    dinheiro: selector(state, 'dinheiro'),
    valorDinheiro: selector(state, 'valorDinheiro'),
    pix: selector(state, 'pix'),
    valorPIX: selector(state, 'valorPIX'),
    valorTEF: selector(state, 'valorTEF'),
    nomeComprovanteVenda: selector(state, 'nomeComprovanteVenda'),
    numeroComprovante: selector(state, 'numeroComprovante'),
    base64Comprovante: selector(state, 'base64Comprovante'),
    nomeComprovanteVendaPIX: selector(state, 'nomeComprovanteVendaPIX'),
    numeroComprovantePIX: selector(state, 'numeroComprovantePIX'),
    base64ComprovantePIX: selector(state, 'base64ComprovantePIX'),
    descontoIda: selector(state, 'descontoIda'),
    descontoVolta: selector(state, 'descontoVolta'),
    quantidadeParcelas: selector(state, 'quantidadeParcelas'),
    valorAcrescimoPassagemCalculado: state.valorAcrescimoPassagemCalculado,
    acrescimoPassagemIda: selector(state, 'acrescimoPassagemIda'),
    acrescimoPassagemVolta: selector(state, 'acrescimoPassagemVolta')

});

export default withRouter(connect(mapStateToProps,
    {
        buscarCaixaAberto,
        adicionarPassageirosIda,
        adicionarPassageirosVolta,
        selecionarReservasRemarcacao,
        adicionarFormasPagamento,
        adicionarDadosComprador,
        selecionarDestino,
        selecionarOrigem,
        selecionarDataIda,
        selecionarViagem,
        cadastrarReserva,
        pagarPedido,
        remarcarReservas,
        alterarTipoEmissaoPassageiroIda,
        alterarTipoEmissaoPassageiroVolta,
        selecionarDescontoUsuario,
        buscarTiposDocumento,
        limpaViagens,
        informarVendaEmMassa,
        verificarItinerarioAtivoOuInativo,
        selecionarUsuario,
        selecionarAcrescimoPassagemCalculado,
        alterarReservaParaCriada,
        verificarPagamento,
        alterarSituacaoFormaPagamentoReservaCriada,
        usuarioEmpresaHabilitadoPagamentoViaPOS,
        usuarioEmpresaHabilitadoPagamentoViaTEF,
        usuarioEmpresaHabilitadoPagamentoViaLink,        
        usuarioEmpresaHabilitadoCieloEcommerce,
        usuarioEmpresaHabilitadoSicoob,
        usuarioEmpresaHabilitadoStoneConnect,
        pagarPedidoLink,
        pagarPedidoCieloEcommerce,
        pagarPedidoSicoob,
        pagarPedidoStoneConnect,
        cancelarPedidoStoneConnect,
        recuperarFormaPagamentosDesativados,
        recuperarPagamentosDesativadosUsuario

    })(reduxForm({
    form: 'formReserva',
    enableReinitialize: true,
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
})(PainelVenderPassagem)));
